import React, { useEffect, useMemo, useState } from "react";
import ReactApexChart from "react-apexcharts";

const PieChart = ({ series, colors, labels}) => {
  const chartData = useMemo(() => {
    return ({
      series: series,
      options: {
        chart: {
          width: 380,
          type: "pie",
        },
        colors: colors,
        labels: labels,
        legend: {
          show: false, // This will hide the legend
        },
        stroke: {
          width: 0, // Remove white separator lines
        },
        dataLabels: {
          enabled: false, // Disable value labels on the pie
        },
        tooltip: {
          enabled: true, // Enable tooltip on hover to show values
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
    })
  }, [series, colors, labels]);

  return (
    <div>
      <div id="chart">
        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type="pie"
          className={"w-100"}
          // width={380}
        />
      </div>
      <div id="html-dist"></div>
    </div>
  );
};

export default PieChart;
